/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Single_Locale_SectionInputs */

const cs_blog_ai_single_locale_section = /** @type {(inputs: Blog_Ai_Single_Locale_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Návrh a úprava`)
};

const en_blog_ai_single_locale_section = /** @type {(inputs: Blog_Ai_Single_Locale_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft & polish`)
};

/**
* | output |
* | --- |
* | "Draft & polish" |
*
* @param {Blog_Ai_Single_Locale_SectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_single_locale_section = /** @type {((inputs?: Blog_Ai_Single_Locale_SectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Single_Locale_SectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_single_locale_section(inputs)
	return cs_blog_ai_single_locale_section(inputs)
});